import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { getDetail } from "../api/basicGenericTable";
import { DictionaryFormDto, FormErrors } from "../types";
import { ApiErrorResponse } from "../../../../types/ApiErrorResponse";

type DictionaryFormProps = {
    formData: DictionaryFormDto;
    setFormData: (formData: DictionaryFormDto) => void;
    errors: FormErrors;
    table: string;
    hasCode?: boolean;
    nextEntryIdPreview?: number | null;
};

export default function DictionaryForm({
    formData,
    setFormData,
    errors,
    table,
    hasCode = false,
    nextEntryIdPreview
}: DictionaryFormProps) {
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const isEditMode = Boolean(id);

    useEffect(() => {
        if (!isEditMode || !id) return;

        getDetail(id, table)
            .then(data => {
                const resolvedDescription = data.description ?? (data as any).descripcio;
                setFormData({
                    ...data,
                    description: resolvedDescription
                });
            })
            .catch((err: ApiErrorResponse) => {
                console.error(err);
            });
    }, [isEditMode, id, table, setFormData]);

    const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFormData({
            ...formData,
            code: value
        });
    };

    const handleDescriptionChange = (field: "catalan" | "spanish" | "english" | "french") => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const currentDescription = formData.description ?? {};
        const updatedDescription = {
            ...currentDescription,
            [field]: e.target.value
        };

        setFormData({
            ...formData,
            description: updatedDescription
        });
    };

    return (
        <Form>
            <Row style={{ marginTop: "10px" }}>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("genericDic:listHeaderId")}</Form.Label>
                        <Form.Control
                            type="text"
                            name="id"
                            disabled
                            value={isEditMode ? formData.id ?? "" : (nextEntryIdPreview ?? "")}
                            readOnly
                        />
                    </Form.Group>
                </Col>
                {hasCode && (
                    <Col xs={4} md={4}>
                        <Form.Group>
                            <Form.Label>{t("genericDic:listHeaderCode")}</Form.Label>
                            <Form.Control
                                type="text"
                                name="code"
                                value={formData.code ?? ""}
                                onChange={handleCodeChange}
                            />
                        </Form.Group>
                    </Col>
                )}
            </Row>

            <Row style={{ marginTop: "20px" }}>
                <Col xs={8} md={8}>
                    <Form.Group>
                        <Form.Label>{t("genericDic:field1NewFormDescriptionCA")}</Form.Label>
                        <Form.Control
                            isInvalid={!!errors.description?.catalan}
                            type="text"
                            name="description"
                            value={formData.description?.catalan ?? ""}
                            onChange={handleDescriptionChange("catalan")}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description?.catalan}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={8} md={8}>
                    <Form.Group>
                        <Form.Label>{t("genericDic:field1NewFormDescriptionES")}</Form.Label>
                        <Form.Control
                            isInvalid={!!errors.description?.spanish}
                            type="text"
                            name="description"
                            value={formData.description?.spanish ?? ""}
                            onChange={handleDescriptionChange("spanish")}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description?.spanish}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={8} md={8}>
                    <Form.Group>
                        <Form.Label>{t("genericDic:field1NewFormDescriptionEN")}</Form.Label>
                        <Form.Control
                            isInvalid={!!errors.description?.english}
                            type="text"
                            name="description"
                            value={formData.description?.english ?? ""}
                            onChange={handleDescriptionChange("english")}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description?.english}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col xs={8} md={8}>
                    <Form.Group>
                        <Form.Label>{t("genericDic:field1NewFormDescriptionFR")}</Form.Label>
                        <Form.Control
                            isInvalid={!!errors.description?.french}
                            type="text"
                            name="description"
                            value={formData.description?.french ?? ""}
                            onChange={handleDescriptionChange("french")}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description?.french}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

             {table === "claimFollowUpType" && (
                <Form.Group>
                    <Form.Check
                        type="checkbox"
                        label={t("genericDic:claimFollowUpTypeCheckobx")}
                        checked={!!formData.isUpdateInformation}
                        onChange={(e) =>{
                            setFormData({...formData, isUpdateInformation: e.target.checked });
                        }
                            
                            
                        }
                    />
                </Form.Group>
                )} 
                {table === "surveyClosedReason" && (
                    <Form.Group>
                        <Form.Check
                            type="checkbox"
                            label={t("genericDic:surveyClosedReasonCheckoboxIsAutomaticValue")}
                            checked={!!formData.isAutomaticValue}
                            onChange={(e) => {
                                setFormData({ ...formData, isAutomaticValue: e.target.checked });
                            }


                            }
                        />
                    </Form.Group>
                )} 
                
        </Row>
        </Form>
    );
}


